import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemeMode } from '../theme/theme-provider.js';

const ORDER: ThemeMode[] = ['system', 'light', 'dark'];
const ICON = { system: Monitor, light: Sun, dark: Moon } as const;
const LABEL = { system: 'System', light: 'Light', dark: 'Dark' } as const;

export function ThemeToggle() {
  const { mode, setMode } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex items-center gap-0.5 rounded-md border p-0.5"
      style={{ borderColor: 'var(--border-line)', background: 'var(--bg-surface)' }}
    >
      {ORDER.map((m) => {
        const Icon = ICON[m];
        const active = mode === m;
        return (
          <button
            key={m}
            role="radio"
            aria-checked={active}
            aria-label={LABEL[m]}
            onClick={() => setMode(m)}
            className="flex h-6 w-6 items-center justify-center rounded transition-colors"
            style={{
              color: active ? 'var(--fg-high)' : 'var(--fg-low)',
              background: active ? 'var(--bg-hover)' : 'transparent',
            }}
            title={`Theme: ${LABEL[m]}`}
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={2} />
          </button>
        );
      })}
    </div>
  );
}
